import PartnersView from 'components/organisms/partners/PartnersView'


const Partners = () => {
  return (
    <PartnersView/>
  )
}

export default Partners